import React from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import GlobalStyles from "./components/GlobalStyles";
import Nav from "./components/Nav";
// Import pages down here
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
// Animation
import { AnimatePresence } from "framer-motion";
import Vision from "./pages/Vision";

function App() {
  const location = useLocation();

  return (
    <div>
      <GlobalStyles />
      <Nav />
      <AnimatePresence exitBeforeEnter>
        <Switch 
          location={location} 
          key={location.pathname}
        >
          <Route path="/" exact>
            <AboutUs />
          </Route>
          <Route path="/contact" exact>
            <ContactUs />
          </Route>
          <Route path="/vision" exact>
            <Vision />
          </Route>
        </Switch>
      </AnimatePresence>
    </div>
  );
}

export default App;
